import Typography from '@mui/material/Typography';
import { ISearchListProps } from './interface';

export const withLoadingList =
  (Component: any) => (props: ISearchListProps) => {
    if (props.isLoading) {
      return (
        <Typography textAlign="center" pb={2} pt={4}>
          Buscando resultados...
        </Typography>
      );
    }

    return <Component {...props} />;
  };
